import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "space-hero" }

import type { LearningSpace } from '~/shared/contracts/lms'

export default /*@__PURE__*/_defineComponent({
  __name: 'LearningSpaceHero',
  props: {
    space: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("span", null, _toDisplayString(__props.space.kind.replace('_', ' ')) + " · " + _toDisplayString(__props.space.periodId || 'lintas periode'), 1),
      _createElementVNode("h1", null, _toDisplayString(__props.space.title), 1),
      _createElementVNode("p", null, _toDisplayString(__props.space.description || 'Ruang pembelajaran aktif.'), 1)
    ]),
    _createElementVNode("aside", null, [
      _createElementVNode("strong", null, _toDisplayString(__props.space.courseCode || 'LMS'), 1),
      _createElementVNode("small", null, _toDisplayString(__props.space.section ? `Kelas ${__props.space.section}` : __props.space.status), 1)
    ])
  ]))
}
}

})